import { Icon as IconComponent } from '@elfsight/lib-icon';
import { useIsMobile } from '@elfsight/widget-utils';
import { useSettings } from '@wu/widget-core';
import { getStyleConfig } from '../../../constants/style-config';

export const Icon = () => {
  const { icon, iconColor, barSize, barSizeMobile } = useSettings();

  const isMobile = useIsMobile();

  const iconSize =
    getStyleConfig(isMobile).icon[isMobile ? barSizeMobile : barSize];

  if (!icon?.url) return;

  return <IconComponent fill={iconColor} src={icon?.url} size={iconSize} />;
};
